import { errorActions } from '@content-platform/web-angular-shared-util-error-handling';
export const LOAD_BY_ID = '[Role] LOAD BY ID';
export const LOAD_BY_ID_SUCCESS = '[Role] LOAD BY ID SUCCESS';
export const LOAD_BY_ID_FAILED = '[Role] LOAD BY ID FAILED';
export const LOAD = '[Role] LOAD';
export const LOAD_SUCCESS = '[Role] LOAD SUCCESS';
export const LOAD_FAILED = '[Role] LOAD FAILED';
export const UPDATE = '[Role] UPDATE';
export const UPDATE_SUCCESS = '[Role] UPDATE SUCCESS';
export const UPDATE_FAILED = '[Role] UPDATE FAILED';
export const DELETE = '[Role] DELETE';
export const DELETE_SUCCESS = '[Role] DELETE SUCCESS';
export const DELETE_FAILED = '[Role] DELETE FAILED';
export const CREATE = '[Role] CREATE';
export const CREATE_SUCCESS = '[Role] CREATE SUCCESS';
export const CREATE_FAILED = '[Role] CREATE FAILED';
export class LoadById {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_BY_ID;
    }
}
export class LoadByIdSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_BY_ID_SUCCESS;
    }
}
export class LoadByIdFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = LOAD_BY_ID_FAILED;
    }
}
export class Load {
    constructor(payload = null) {
        this.payload = payload;
        this.type = LOAD;
    }
}
export class LoadSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_SUCCESS;
    }
}
export class LoadFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = LOAD_FAILED;
    }
}
export class Update {
    constructor(payload) {
        this.payload = payload;
        this.type = UPDATE;
    }
}
export class UpdateSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = UPDATE_SUCCESS;
    }
}
export class UpdateFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = UPDATE_FAILED;
    }
}
export class Delete {
    constructor(payload) {
        this.payload = payload;
        this.type = DELETE;
    }
}
export class DeleteSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = DELETE_SUCCESS;
    }
}
export class DeleteFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = DELETE_FAILED;
    }
}
export class Create {
    constructor(payload) {
        this.payload = payload;
        this.type = CREATE;
    }
}
export class CreateSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = CREATE_SUCCESS;
    }
}
export class CreateFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = CREATE_FAILED;
    }
}
//# sourceMappingURL=role.actions.js.map